import { render, staticRenderFns } from "./listadoExpedientes.vue?vue&type=template&id=367b3fdd&"
import script from "./listadoExpedientes.vue?vue&type=script&lang=js&"
export * from "./listadoExpedientes.vue?vue&type=script&lang=js&"
import style0 from "./listadoExpedientes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports